import { ActionType } from '../constants';
import type { ThresholdLeft, ThresholdRight } from '../types';

export const defaultOperatorByActionType = {
  [ActionType.TAG]: 'lt',
  [ActionType.OUTCOME_REASON]: 'e',
};

export const defaultOperatorByDataType = {
  boolean: 'e',
  string: 'e',
  integer: 'lt',
  decimal: 'lt',
  date: 'lt',
  timestamp: 'lt',
  reasoncodes: 'in',
};

export const emptyThresholdLeft: ThresholdLeft = {
  actionId: null,
  attributeId: null,
  attributeToken: null,
  attributeComponents: [],
  aggregationComponents: [],
};

export const emptyThresholdRight: ThresholdRight = {
  actionId: null,
  attributeId: null,
  attributeToken: null,
  attributeComponents: [],
  reasonCodeGroupId: null,
  reasonCodeGroup: null,
  attributeValue: null,
  leftTagActionResult: null,
  aggregationComponents: [],
};
